/** Columns the routine list can sort. Asset and activity stay on the current page. */
export const ROUTINE_SORT_FIELDS = [
  'taskNumber',
  'startDate',
  'name',
  'description',
  'asset',
  'quantity',
  'activity',
  'status',
] as const;

/**
 * These map to Task columns and are ordered in the database before pagination.
 * Asset and activity are related-row labels, so they are not in this set.
 */
export const ROUTINE_SERVER_SORT_FIELDS = new Set<string>([
  'taskNumber',
  'startDate',
  'name',
  'description',
  'quantity',
  'status',
]);

const ALLOWED = new Set<string>(ROUTINE_SORT_FIELDS);

export function parseRoutineSort(searchParams: URLSearchParams): {
  sortBy: string | null;
  sortOrder: 'asc' | 'desc';
} {
  const raw = searchParams.get('sortBy');
  const sortBy = raw && ALLOWED.has(raw) ? raw : null;
  const sortOrder = searchParams.get('sortOrder') === 'desc' ? 'desc' : 'asc';
  return { sortBy, sortOrder };
}

export function nextRoutineSortOrder(
  sortBy: string | null,
  sortOrder: 'asc' | 'desc',
  field: string
): 'asc' | 'desc' {
  return sortBy === field && sortOrder === 'asc' ? 'desc' : 'asc';
}
